import * as Header from '../components/header';
import { Browser } from '../utils/browsercheck';
import { onDomReady } from '../utils/dom';
import * as ScrollUtil from '../utils/scrolling';

function deleteEmptyPTags() {
    // Lösche leere p Tags mit Leerzeichen
    for (const p of document.querySelectorAll('#main p')) {
        if (p.innerHTML.replace(/\s| |&nbsp;/g, '') === '') {
            p.remove();
        }
    }
}

function addExternalLinkClass() {
    const not = ':not(.social-link)';

    /** @type {NodeListOf<HTMLAnchorElement>} */
    const links = document.querySelectorAll(`a[href^="http://"]${not}, a[href^="https://"]${not}`);

    for (const a of links) {
        if (!a.hostname.endsWith(location.hostname) && !a.parentElement.classList.contains('image_container')) {
            a.classList.add('external-link');
        }
    }

    const kdeLink = document.querySelector('#footer a.kde-text-logo');

    if (kdeLink) {
        kdeLink.setAttribute('target', '_blank');
        kdeLink.ariaLabel = 'Zu unseren Bewertungen auf KennstDuEinen';
    }
}

function setCustomProperties() {
    const footer = document.getElementById('footer');

    document.body.style.setProperty('--header-height', `${Header.getHeight(true)}px`);
    document.body.style.setProperty('--scrollbar-width', `${Browser.scrollbarWidth}px`);
    document.body.style.setProperty('--footer-height', `${footer.offsetHeight}px`);
}

function setTouchDeviceClass() {
    if (Browser.isTouchDevice()) {
        document.documentElement.classList.add('touch');
    }
}

function fullHeight() {
    for (const img of document.querySelectorAll('.full-height img')) {
        img.style.height = `calc(100vh - ${Header.getHeight()}px)`;
    }
}

function scrollToAnchor() {
    for (const a of document.querySelectorAll('a[href*="#"]')) {
        a.addEventListener('click', function (e) {
            ScrollUtil.scrollToAnchor(e, this);
        });
    }
}

/**
 * Seite einblenden wenn sie fertig geladen ist
 */
function fadeInSite() {
    const loader = document.getElementById('page-loader');

    if (loader) {
        loader.classList.add('hide');
    }

    setTimeout(() => document.documentElement.classList.replace('loading', 'loaded'), 400);
}

function addLoadingClassToImages() {
    /** @type {NodeListOf<HTMLImageElement>} */
    const images = document.querySelectorAll('img:not([href$=".svg"]');

    if (!images.length) {
        return;
    }

    images.forEach((img) => {
        if (img.complete && img.naturalHeight !== 0) {
            return;
        }

        if (img.hasAttribute('width')) {
            img.style.setProperty('--loading-width', `${img.getAttribute('width')}px`);
        }

        img.classList.add('loading');
        img.onload = () => img.classList.remove('loading');
    });
}

function deleteDuplicateRatingData() {
    const ratings = document.querySelectorAll('#kde-widget');

    if (ratings.length > 1) {
        for (let i = 1; i < ratings.length; i++) {
            ratings[i].parentElement.remove();
        }
    }
}

onDomReady(() => {
    addLoadingClassToImages();
    addExternalLinkClass();

    deleteEmptyPTags();
    setCustomProperties();
    setTouchDeviceClass();
    fullHeight();
    scrollToAnchor();
    deleteDuplicateRatingData();
});

window.addEventListener('load', () => {
    fadeInSite();
    setCustomProperties();

    ScrollUtil.scrollToAnchor(null, window.location);
});

window.addEventListener('resize', () => {
    fullHeight();
    setCustomProperties();
});
